import React from 'react'
import {styled} from '@material-ui/core/styles'
import SectionTitle from 'lms/components/Detail/SectionTitle'

const List = styled('ul')({})

const Value = styled('li')({})

const SystemType = ({type}) => {
  if (!type || (Array.isArray(type) && type.length === 0)) return null

  const types = Array.isArray(type) ? type : [type]

  return (
    <>
      <SectionTitle>Learning System Type</SectionTitle>
      <List>
        {types.map(t => (
          <Value key={t}>{t}</Value>
        ))}
      </List>
    </>
  )
}

export default SystemType
